import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { ProcedureType } from "../../app/types/genericTables.types";

type UseProcedureType = {
  procedureList: ProcedureType[];
  get: (id: ProcedureType["id"]) => ProcedureType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useSamplingProcedure = create<UseProcedureType>((set, get) => ({
  loading: false,
  procedureList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().procedureList.find((procedure) => procedure.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Procedimientos";
      const { data: response } = await getData(endpoint);
      set(() => ({
        procedureList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
}));
